import { IFolder } from "api/rpc/2022-09/facilityAdmin/product/folder";
import React from "react";
import "./tableServiceFoldersMenu.scss";
import { IUIActions } from "redux/actions/ui";
import { faFolder } from "@fortawesome/pro-regular-svg-icons";
import { allIcons } from "components/IconSelector/iconSelector";
import TableServiceFolderItem from "./TableServiceFolderItem";

interface IProps {
  uiActions: IUIActions;
  folders: IFolder[];
  selectedFolder: IFolder;
  setSelectedFolder: (selectedFolder: IFolder) => void;
  iconName?: string;
}

export default function TableServiceFoldersMenu(props: IProps) {
  const { folders, selectedFolder, setSelectedFolder } = props;

  return (
    <ul className="table-service-folders-menu">
      {folders
        ?.sort((prev, next) => prev.position - next.position)
        ?.map((folder, index: number) => {
          return (
            <TableServiceFolderItem
              key={index}
              active={selectedFolder === folder}
              onClick={() => setSelectedFolder(folder)}
              icon={folder.icon_name ? allIcons[folder.icon_name] : faFolder}
              title={folder?.title}
            />
          );
        })}
    </ul>
  );
}
